/**
 * 内置功能，格式化body值
 */

import { IString } from '../../../model';
import { IConfigField, IValue } from '../model';

// value映射select/checkbox的label
export const getTableBodyLinkageValue = <T>(
  selectedValue: IValue,
  fieldConfig: IConfigField<T>
) => {
  const { valueLinkageLabel } = fieldConfig.tableExtension || {};
  const { jsonData } = fieldConfig.fieldOptExtension || {};
  if (valueLinkageLabel && jsonData && selectedValue) {
    const json: IString<any> = jsonData[selectedValue.value];
    if (json) {
      return json[valueLinkageLabel] || selectedValue.value;
    }
  }
  return null;
};
